import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const LoginRedirect = (props) => {
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    // The Auth0 tokens in the address bar shouldn't stay in the browser history
    window.history.replaceState(null, "", location.pathname);

    // Successfully logged with the provider
    // Now logging with strapi by using the access_token (given by the provider) in props.location.search
    fetch(`${backendUrl}/api/auth/auth0/callback${location.search}`)
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(`Couldn't login to Strapi. Status: ${res.status}`);
        }
        return res;
      })
      .then((res) => res.json())
      .then((res) => {
        // Successfully logged with Strapi
        // Now saving the jwt to use it for future authenticated requests to Strapi
        const cookieOptions = {
          path: "/",
          secure: window.location.protocol === "https:",
          sameSite: "lax",
        };
        cookies.set("veemind-app-token", res.jwt, cookieOptions);
        cookies.set("veemind-username", res.user.username, cookieOptions);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        navigate("/", { replace: true });
      });
  }, [navigate, location.search, location.pathname]);

  return "";
};

export default LoginRedirect;
